(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dw-product-manuals"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dw-manual-library')){
  customElements.define('dw-manual-library',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.limit=Number(this.dataset.size)||12;this.size=this.limit;
      this.grid=this.querySelector('[data-grid]');this.input=this.querySelector('input');this.status=this.querySelector('[data-status]');this.messages=this.querySelector('[data-messages]').dataset;
      this.next=this.querySelector('[data-next]').dataset.next;this.busy=false;this.failed=false;
      this.input.addEventListener('input',()=>{this.limit=this.size;this.filter()});
      this.querySelector('[data-clear]').addEventListener('click',()=>{this.input.value='';this.limit=this.size;this.filter();this.input.focus()});
      this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=this.size;this.filter()});
      this.querySelector('[data-retry]').addEventListener('click',()=>this.load());this.filter();this.load();
    }
    normalize(value){return value.toLowerCase().replace(/[^a-z0-9\u00c0-\u024f]/g,'')}
    filter(){
      const terms=this.input.value.trim().replace(/\b(?:ls|ql)[\s_-]*(?=(?:\d|mb))/gi,'').split(/\s+/).map(v=>this.normalize(v)).filter(Boolean);let found=0;
      this.grid.querySelectorAll('[data-manual]').forEach(card=>{const key=this.normalize(card.dataset.keywords);const match=terms.every(t=>key.includes(t));card.hidden=!match||++found>this.limit});
      this.status.textContent=this.busy?this.messages.loading:(this.failed?this.messages.error:this.messages.results.replace('{count}',String(found)));
      this.querySelector('[data-empty]').hidden=found>0||this.busy||this.failed;
      this.querySelector('[data-more]').hidden=found<=this.limit;this.querySelector('[data-retry]').hidden=!this.failed;
    }
    async load(){
      if(this.busy||!this.next)return;this.busy=true;this.failed=false;this.filter();
      try{
        while(this.next&&this.isConnected){
          const url=new URL(window.location.href);const next=new URL(this.next,window.location.origin);
          next.searchParams.forEach((value,key)=>url.searchParams.set(key,value));url.searchParams.set('section_id',this.dataset.section);
          const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw Error('load');
          const documentPart=new DOMParser().parseFromString(await response.text(),'text/html');const root=documentPart.querySelector('dw-manual-library');if(!root)throw Error('section');
          const ids=new Set(Array.from(this.grid.querySelectorAll('[data-id]'),x=>x.dataset.id));
          root.querySelectorAll('[data-manual]').forEach(card=>{if(!ids.has(card.dataset.id)){card.hidden=true;this.grid.append(document.importNode(card,true))}});
          const following=root.querySelector('[data-next]').dataset.next;if(following===this.next)throw Error('pagination');this.next=following;this.filter();
        }
      }catch(error){this.failed=true}finally{this.busy=false;this.filter()}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q4-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('q4-video-filter')) {
  class Q4VideoFilter extends HTMLElement {}
  customElements.define('q4-video-filter', Q4VideoFilter);
}

  } catch(e) { console.error(e); }
})();
})();
